/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import makeStyles from '@mui/styles/makeStyles'
import InformationalTooltip from './InformationalTooltip'

export default function TokTokDocTextField({
    id,
    defaultValue,
    validator,
    callback,
    tooltipText,
    needToBeReset,
    noMargin,
    defaultState = undefined,
    ...rest
}: any) {
    const [value, setValue] = useState(defaultValue)
    const [error, setError] = useState(false)
    const [helperText, setHelperText] = useState('')

    const useStyles = makeStyles(() => ({
        TokTokDocTextField: {
            marginTop: '0.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: !noMargin ? '1rem' : 0,
            '& .MuiFormControl-root': {
                '& .MuiFormHelperText-root.Mui-error': {
                    fontSize: '1rem',
                    lineHeight: '1.5rem',
                    fontWeight: 700,
                },
            },
        },
        TextField: {
            paddingRight: '1.5rem',
            width: '100%',
        },
    }))

    const classes = useStyles()

    useEffect(() => {
        if (defaultState === 'ERROR' && !value) {
            setError(true)
            return
        }
        const result = validator(value)
        if (result !== true) {
            setError(true)
            setHelperText(result)
        } else {
            setError(false)
            setHelperText('')
        }
    }, [value])

    useEffect(() => {
        if (needToBeReset) setValue('')
    }, [needToBeReset])

    /**
     * @description handle change value
     * @param {*} event
     * @returns {void}
     */
    const handleChange = (event: any) => {
        setValue(event.target.value)
    }

    /**
     * @description handle on enter key press
     * @param {*} event
     * @returns {void}
     */
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter' && callback && value !== '' && validator(value) === true) {
            callback(id, value)
            setValue(defaultValue)
        }
    }

    return (
        <div className={classes.TokTokDocTextField}>
            <TextField
                variant="outlined"
                {...rest}
                value={value}
                error={error}
                helperText={helperText}
                onChange={handleChange}
                onKeyPress={(event) => handleKeyPress(event)}
                className={classes.TextField}
            />
            {tooltipText ? <InformationalTooltip title={tooltipText} /> : null}
        </div>
    )
}
